import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ProfileProvider } from "./context/ProfileContext";
import { ActiveProfileProvider } from "./context/ActiveProfileContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { StyleSheetManager } from "styled-components";
import isPropValid from "@emotion/is-prop-valid";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <ActiveProfileProvider>
        <ProfileProvider>
          <StyleSheetManager shouldForwardProp={(prop) => isPropValid(prop)}>
            <App />
          </StyleSheetManager>
        </ProfileProvider>
      </ActiveProfileProvider>
    </QueryClientProvider>
  </HelmetProvider>,
);

reportWebVitals((metric) => {
  if (
    typeof window !== "undefined" &&
    typeof (window as any).clarity === "function"
  ) {
    (window as any).clarity("set", metric.name, String(metric.value));
  }
});
